import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import TableHeaderProduto from '../../../Components/PDF/TableHeaderProdutos'
import TableRowProdutos from '../../../Components/PDF/TableRowProdutos'
import TableFooterProdutos from '../../../Components/PDF/TableFooterProdutos'

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 5,
    borderWidth: 1,
    borderColor: '#ccc',
  },
  titulo: {
    display: "flex",
    flexDirection: 'row',
    justifyContent: "center",
    alignItems: "center",
    fontSize: 20,
    textAlign: "center",
    marginTop: 5,
  },
});

export default function Produtos({ produtos, juros, desconto }) {

  return (
    <>
      <Text style={styles.titulo}>Produtos</Text>
      <View style={styles.tableContainer}>
        <TableHeaderProduto />
        <TableRowProdutos items={produtos} />
        <TableFooterProdutos items={produtos} juros={juros} desconto={desconto}/>
      </View>
    </>

  )
}  
